import { fetchApi } from '@/config/axiosSetting';
import { SignatureQueryParamsType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const postBodySignatureQueryFunction = (
  params: Omit<SignatureQueryParamsType, 'damagedId'>,
): Promise<{}> => {
  return fetchApi({
    method: 'post',
    url: `/body/reports/${params.id}/images/signature/`,
    data: params.data,
  });
};
